<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        data-name="Layer 1"
        width="200"
        height="170"
        viewBox="0 0 200 170"
    >
        <defs>
            <linearGradient
                id="cancel-plan-gradient"
                x1="100"
                y1="0"
                x2="100"
                y2="170"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#f86d70" stop-opacity="0.2" />
                <stop offset="0.54" stop-color="#f86d70" stop-opacity="0.1" />
                <stop offset="1" stop-color="#f86d70" stop-opacity="0.05" />
            </linearGradient>
        </defs>
        
        <!-- Background decorative circles -->
        <circle cx="100" cy="85" r="65" fill="url(#cancel-plan-gradient)" />
        
        <!-- Main cancel icon circle -->
        <circle cx="100" cy="60" r="32" fill="#f86d70" opacity="0.15" />
        <circle cx="100" cy="60" r="28" fill="none" stroke="#f86d70" stroke-width="2.5" stroke-opacity="0.4" />
        
        <!-- X mark (cancel icon) -->
        <g stroke="#f86d70" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">
            <line x1="85" y1="45" x2="115" y2="75" />
            <line x1="115" y1="45" x2="85" y2="75" />
        </g>
        
        <!-- Document/Plan illustration at bottom -->
        <g transform="translate(60, 105)">
            <rect x="0" y="0" width="80" height="50" rx="4" fill="#3f3d56" opacity="0.08" />
            <rect x="4" y="4" width="72" height="42" rx="2" fill="#fff" opacity="0.95" />
            <!-- Document lines -->
            <line x1="14" y1="14" x2="66" y2="14" stroke="#3f3d56" stroke-width="1.5" opacity="0.25" />
            <line x1="14" y1="22" x2="58" y2="22" stroke="#3f3d56" stroke-width="1.5" opacity="0.2" />
            <line x1="14" y1="30" x2="52" y2="30" stroke="#3f3d56" stroke-width="1.5" opacity="0.2" />
            <!-- Cancel mark on document -->
            <circle cx="70" cy="12" r="6" fill="#f86d70" opacity="0.2" />
            <line x1="67" y1="9" x2="73" y2="15" stroke="#f86d70" stroke-width="1.5" stroke-linecap="round" />
            <line x1="73" y1="9" x2="67" y2="15" stroke="#f86d70" stroke-width="1.5" stroke-linecap="round" />
        </g>
        
        <!-- Decorative warning dots -->
        <circle cx="35" cy="35" r="2.5" fill="#f86d70" opacity="0.3" />
        <circle cx="165" cy="35" r="2.5" fill="#f86d70" opacity="0.3" />
        <circle cx="35" cy="135" r="2.5" fill="#f86d70" opacity="0.3" />
        <circle cx="165" cy="135" r="2.5" fill="#f86d70" opacity="0.3" />
    </svg>
</template>

<script>
export default {
    name: "CancelPlan"
};
</script>

